import { render, staticRenderFns } from "./LayoutCard.vue?vue&type=template&id=fba80d9e&scoped=true"
import script from "./LayoutCard.vue?vue&type=script&lang=js"
export * from "./LayoutCard.vue?vue&type=script&lang=js"
import style0 from "./LayoutCard.vue?vue&type=style&index=0&id=fba80d9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fba80d9e",
  null
  
)

export default component.exports